import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    hostingTypes: [],
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.LANDINGS_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.LANDINGS_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.LANDINGS_FAIL:
            return {
                ...state,
                loading: false
            };

        case AppConstants.LANDINGS_HOSTING_TYPES_SUCCESS:
            return {
                ...state,
                hostingTypes: action.items
            };

        default:
            return state;
    }
};
